<app-table
  (focusDateChange)="focusDateChange($event)"
  [columns]="columns"
  [firstColumnFrozen]="true"
  [focusDate]="focusDate"
  [footer]="true"
  [hasFocusDate]="true"
  [headerGroups]="headerGroups"
  [loading]="loading"
  [showFrozenColumnSelection]="false"
  [sortField]="'tacsIdAndName'"
  [value]="value">
  <ng-template
    (onClick)="organisationalUnitOverlayPanel.toggle($event)"
    appToolbarButton
    icon="fal fa-sitemap"
    labelKey="ASSIGNMENT.ORGANISATIONAL_UNIT_FILTER"></ng-template>

  @if (!emptyRowsHidden) {
    <ng-template
      (onClick)="hideEmptyRows()"
      appToolbarButton
      icon="fal fa-align-slash"
      labelKey="GLOBAL.HIDE_EMPTY_ROWS"></ng-template>
  }

  @if (emptyRowsHidden) {
    <ng-template
      (onClick)="showEmptyRows()"
      appToolbarButton
      icon="fal fa-filter"
      labelKey="GLOBAL.SHOW_ALL"></ng-template>
  }
</app-table>

<p-popover
  (onHide)="updateColumns()"
  [hideTransitionOptions]="'0ms'"
  [showTransitionOptions]="'0ms'"
  #organisationalUnitOverlayPanel>
  <div class="grid grid-cols-12">
    <div class="col-span-12">
      <p-listbox
        [(ngModel)]="selectedOrganisations"
        [checkbox]="true"
        [filter]="true"
        [listStyle]="{ 'max-height': '250px' }"
        [multiple]="true"
        [options]="organisations"
        [showToggleAll]="true"
        [style]="{ width: '100%' }"
        optionLabel="bezeichnung"
        optionValue="id"></p-listbox>
    </div>

    @if (selectedOrganisations.length > maxOrganisations) {
      <div class="col-span-12">
        <p-message [text]="'ASSIGNMENT.TOO_MANY_COLUMNS' | translate" severity="warn"></p-message>
      </div>
    }

    <div class="col-span-12">
      <p-button
        (onClick)="organisationalUnitOverlayPanel.hide()"
        [label]="'ACTIONS.OK' | translate"
        icon="fal fa-check"></p-button>
    </div>
  </div>
</p-popover>

<p-dialog [(visible)]="dialogVisible" [header]="'GLOBAL.DETAILS' | translate" [modal]="true">
  @if (dialogVisible) {
    <form (ngSubmit)="save()" [formGroup]="form" novalidate style="width: 560px">
      <app-form-time-period
        [form]="form"
        [inputType]="'number'"
        [maxFractionDigits]="2"
        [minFractionDigits]="0"
        id="value"></app-form-time-period>
      <app-form-button-bar
        (onCancel)="dialogVisible = false"
        [form]="form"
        [offset]="false"
        [saveDisabled]="submitting"></app-form-button-bar>
    </form>
  }
</p-dialog>
